// extracted by mini-css-extract-plugin
export default {"dot932":"dot_dot932__s87I2","dot2294":"dot_dot2294__Y+CoH","dot2705":"dot_dot2705__9aBfj"};